import type { LngLatBoundsLike } from 'mapbox-gl';

export const GEOGRAPHIC_AT_BBOX: LngLatBoundsLike = [
  [9.49, 46.41],
  [17.18, 49.04],
];
